import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dot03M"
);
